import { getNotificationCount } from '../../api/notification'
// initial state
// shape: [{ id, quantity }]
const state = () => ({
  groups: ['NCT','NCT127','NCT Dream','WayV'],
  nct127Members: ['泰一','Johnny','泰容','悠太','道英','在玹','廷祐','Mark','楷燦'],
  nctdreamMembers: ['Mark','仁俊','Jeno','楷燦','渽民','辰樂','志晟'],
  wayvMembers: ['錕','Ten','昀昀','Lucas','肖俊','Hendery','揚揚'],
  // nctMembers: [{groupName:'NCT 127',members:['泰一','Johnny','泰容','悠太','道英','在玹','廷祐','Mark','楷燦']},{groupName:'NCT Dream',members:['Mark','仁俊','Jeno','楷燦','渽民','辰樂','志晟']},{groupName:'WayV',members:['錕','Ten','昀昀','Lucas','肖俊','Hendery','揚揚']},{groupName:'NCT',members:['將太郎','成燦']}],
  nctMembers: ['泰一','Johnny','泰容','悠太','道英','在玹','廷祐','Mark','楷燦','仁俊','Jeno','渽民','辰樂','志晟','錕','Ten','昀昀','Lucas','肖俊','Hendery','揚揚','將太郎','成燦'],
  nctAlbums: ['NCT 2018 Empathy', 'NCT 2020 : RESONANCE Pt. 1','NCT 2020 : RESONANCE Pt. 2'],
  nct127Albums: ['NCT #127','Limitless','Cherry Bomb','Chain','Regular-Irregular', 'Regulate','Neo Zone','We Are Superhuman','Awaken','The Final Round','LOVEHOLIC'],
  nctdreamAlbums: ['The First','We Young','We Go Up','WE BOOM','Reload','Hot Sauce','Hello Future'],
  wayvAlbums: ['Awaken The World','Take Off','Take Over the Moon'],


})

// getters
const getters = {
//   cartProducts: (state, getters, rootState) => {
//     return state.items.map(({ id, quantity }) => {
//       const product = rootState.products.all.find(product => product.id === id)
//       return {
//         title: product.title,
//         price: product.price,
//         quantity
//       }
//     })
//   },

//   cartTotalPrice: (state, getters) => {
//     return getters.cartProducts.reduce((total, product) => {
//       return total + product.price * product.quantity
//     }, 0)
//   }
}

// actions
const actions = {
//   checkout ({ commit, state }, products) {
//     const savedCartItems = [...state.items]
//     commit('setCheckoutStatus', null)
//     // empty cart
//     commit('setCartItems', { items: [] })
//     shop.buyProducts(
//       products,
//       () => commit('setCheckoutStatus', 'successful'),
//       () => {
//         commit('setCheckoutStatus', 'failed')
//         // rollback to the cart saved before sending the request
//         commit('setCartItems', { items: savedCartItems })
//       }
//     )
//   },

//   addProductToCart ({ state, commit }, product) {
//     commit('setCheckoutStatus', null)
//     if (product.inventory > 0) {
//       const cartItem = state.items.find(item => item.id === product.id)
//       if (!cartItem) {
//         commit('pushProductToCart', { id: product.id })
//       } else {
//         commit('incrementItemQuantity', cartItem)
//       }
//       // remove 1 item from stock
//       commit('products/decrementProductInventory', { id: product.id }, { root: true })
//     }
//   }
}

// mutations
const mutations = {
  

//   incrementItemQuantity (state, { id }) {
//     const cartItem = state.items.find(item => item.id === id)
//     cartItem.quantity++
//   },

//   setCartItems (state, { items }) {
//     state.items = items
//   },

//   setCheckoutStatus (state, status) {
//     state.checkoutStatus = status
//   }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}